export const professionalColleges = [

    {
      id: 1,
      jnbId: "30644",
      name: "Sree Sai College of Education, Nandikotkur",
      place: "Nandikotkur",
      district: "Nandyal",
      phone: "7013611196",
      email: "sreesaicoendkru@gmail.com"
    },
    {
      id: 2,
      jnbId: "31724",
      name: "Madina College of Education, Bramhanakotkur",
      place: "B Kotkur",
      district: "Nandyal",
      phone: "",
      email: "madinacollegeofeducation.mdnk@gmail.com"
    },
    {
      id: 3,
      jnbId: "30737",
      name: "Tagore M.Ed College, Kodumur",
      place: "Kodumur",
      district: "Kurnool",
      phone: "9704017652",
      email: "kavalidamodhar@gmail.com"
    },
    {
      id: 4,
      jnbId: "17377",
      name: "Sri Sankaras College of Education, Kurnool",
      place: "Kurnool",
      district: "Kurnool",
      phone: "9676402347",
      email: "srishankarasedu@gmail.com"
    },
    {
      id: 5,
      jnbId: "22077",
      name: "SLV College of Education, Kurnool",
      place: "Kurnool",
      district: "Kurnool",
      phone: "9885424031",
      email: "slvce.knl01@gmail.com"
    },
 

 
    {
      id: 1,
      jnbId: "30133",
      name: "Vijaniketha M.P.Ed College",
      place: "Panyam",
      district: "Nandyal",
      phone: "9030779583",
      email: "goopireddy181@gmail.com"
    },
    {
      id: 2,
      jnbId: "30317",
      name: "Srilakshmi M.P.Ed College",
      place: "Kurnool",
      district: "Kurnool",
      phone: "9440852221",
      email: "principal.srilakshmibped@gmail.com"
    },
   
  {
    id: 1,
    jnbId: "Govt",
    name: "IASE B.Ed College Kurnool",
    place: "Kurnool",
    district: "Kurnool",
    phone: "",
    email: "iasekurnool@yahoo.com"
  },
  {
    id: 2,
    jnbId: "11101",
    name: "Bharathi College of Education",
    place: "Nandyal",
    district: "Nandyal",
    phone: "9248759820",
    email: "bharathicoll@gmail.com"
  },
  {
    id: 3,
    jnbId: "14920",
    name: "Madina College of Education",
    place: "Bramhanakotkur",
    district: "Nandyal",
    phone: "9704040788",
    email: "madinacollegeofeducation.mdnk@gmail.com"
  },
  {
    id: 4,
    jnbId: "15387",
    name: "Mother Theresa College of Education",
    place: "Yemmiganur",
    district: "Kurnool",
    phone: "7013354787",
    email: "motherygr045@gmail.com"
  },
  {
    id: 5,
    jnbId: "16333",
    name: "Prabhath College of Education",
    place: "Parnapalle, Atmakur",
    district: "Nandyal",
    phone: "8341266224",
    email: "pesndl@gmail.com"
  },
  {
    id: 6,
    jnbId: "17403",
    name: "Shantiniketan College of Education",
    place: "Dupadu",
    district: "Kurnool",
    phone: "9100742521",
    email: "rahulpaluru@yahoo.in"
  },
  {
    id: 7,
    jnbId: "17501",
    name: "Satyam College of Education",
    place: "Pyalakurthy",
    district: "Kurnool",
    phone: "9000495490",
    email: "satyammuralik@gmail.com"
  },
  {
    id: 8,
    jnbId: "18692",
    name: "Sri Lakshmi Venkeswara College of Education",
    place: "Kurnool",
    district: "Kurnool",
    phone: "9885424031",
    email: "slvce.knl01@gmail.com"
  },
  {
    id: 9,
    jnbId: "18909",
    name: "Sri Rayalaseema Christian College of Education",
    place: "Kurnool",
    district: "Kurnool",
    phone: "9440375174",
    email: "srcce.knl@gmail.com"
  },
  {
    id: 10,
    jnbId: "24064",
    name: "Haji Kareem College of Education",
    place: "Brahmanakotkur",
    district: "Nandyal",
    phone: "9494223163",
    email: "abdulsaleem30@gmail.com"
  },
  {
    id: 11,
    jnbId: "30498",
    name: "GMR B.Ed College",
    place: "Kalugotla, Yemmiganur",
    district: "Kurnool",
    phone: "9491343417",
    email: "gmrbedyemmiganur@gmail.com"
  },
  {
    id: 12,
    jnbId: "30518",
    name: "St Joseph B.Ed College",
    place: "Kurnool",
    district: "Kurnool",
    phone: "6303410793",
    email: "stjosephb.edcollegeknl@gmail.com"
  },
  {
    id: 13,
    jnbId: "30616",
    name: "Zohars College of Education",
    place: "Nandyal",
    district: "Nandyal",
    phone: "9700700431",
    email: "shamshuzohar@gmail.com"
  },
  {
    id: 14,
    jnbId: "31673",
    name: "Tarakaram B.Ed College",
    place: "Nandyal",
    district: "Nandyal",
    phone: "8328686723",
    email: "djm2183@gmail.com"
  },
  {
    id: 15,
    jnbId: "17377",
    name: "Sri Sankaras College of Education",
    place: "Kurnool",
    district: "Kurnool",
    phone: "9676402347",
    email: "srishankarasedu@gmail.com"
  },
  {
    id: 16,
    jnbId: "17454",
    name: "SARM College of Education",
    place: "Allagadda",
    district: "Nandyal",
    phone: "9000412395",
    email: "ramalingareddypg@gmail.com"
  },
  {
    id: 17,
    jnbId: "18946",
    name: "Sri Sai College of Education",
    place: "Nandikotkur",
    district: "Nandyal",
    phone: "7013611196",
    email: "sreesaicoendkru@gmail.com"
  },
  {
    id: 18,
    jnbId: "20008",
    name: "St Peters College of Education",
    place: "Pathikonda",
    district: "Kurnool",
    phone: "9030776680",
    email: "jayapaul.kota@gmail.com"
  },
  {
    id: 19,
    jnbId: "20387",
    name: "Tagore College of Education",
    place: "Kodumur",
    district: "Kurnool",
    phone: "9704017652",
    email: "kavalidamodhar@gmail.com"
  },
  {
    id: 20,
    jnbId: "27330",
    name: "Osmania College of Education",
    place: "Kurnool",
    district: "Kurnool",
    phone: "9848357405",
    email: "akkocek@gmail.com"
  },
  {
    id: 21,
    jnbId: "30517",
    name: "Navabharath B.Ed College",
    place: "Kurnool",
    district: "Kurnool",
    phone: "9399478658",
    email: "navabharathdbc@gmail.com"
  },
  {
    id: 22,
    jnbId: "30606",
    name: "Abdulla B.Ed College",
    place: "Basitpadu, Kallur",
    district: "Kurnool",
    phone: "9676232911",
    email: "abdullabedcollege786@gmail.com"
  },
  {
    id: 23,
    jnbId: "30833",
    name: "Dr K.V. Subba Reddy B.Ed College",
    place: "Dupadu",
    district: "Kurnool",
    phone: "8328047414",
    email: "drkvsreddy7@gmail.com"
  },
  {
    id: 24,
    jnbId: "31709",
    name: "Sri Saraswathi College of Education",
    place: "Kallur",
    district: "Kurnool",
    phone: "990889760",
    email: "rajamaluga8@gmail.com"
  },
  {
    id: 25,
    jnbId: "32155",
    name: "Varaprasad Rao B.Ed College",
    place: "Panchalingala",
    district: "Kurnool",
    phone: "8885505185",
    email: "vprpbedcollege@gmail.com"
  },
  {
    id: 26,
    jnbId: "32577",
    name: "K. Nagi Reddy College of Education",
    place: "Laxmipuram",
    district: "Kurnool",
    phone: "9966566800",
    email: "knagireddy1182@gmail.com"
  },
  {
    id: 27,
    jnbId: "15621",
    name: "Nalanda College of Education",
    place: "Peddakaduburu",
    district: "Kurnool",
    phone: "8500274201",
    email: "nalandacollegeofeducationygr@gmail.com"
  },
  {
    id: 28,
    jnbId: "12437",
    name: "GMR College of Education",
    place: "Nandyal",
    district: "Nandyal",
    phone: "9966418448",
    email: "gmrcoe312@rediffmail.com"
  },
  {
    id: 29,
    jnbId: "20007",
    name: "St Peters College of Education",
    place: "Adoni",
    district: "Kurnool",
    phone: "7780348964",
    email: "stpetersbed.adoni@gmail.com"
  },
  {
    id: 30,
    jnbId: "18817",
    name: "Sri Raghavendra College of Education",
    place: "Orwakal",
    district: "Kurnool",
    phone: "9440195262",
    email: "srcaalg@gmail.com"
  },
  {
    id: 31,
    jnbId: "20633",
    name: "Ushodaya College of Education",
    place: "Yemmiganur",
    district: "Kurnool",
    phone: "7013149603",
    email: "ushodayabedcollege786@gmail.com"
  },
  {
    id: 32,
    jnbId: "30536",
    name: "Sree Lakshmi Sreenivasa College of Education",
    place: "B Thandrapadu",
    district: "Kurnool",
    phone: "8309526834",
    email: "mrnivas16@gmail.com"
  },
  {
    id: 33,
    jnbId: "30537",
    name: "Sumourya College of Education",
    place: "B Thandrapadu",
    district: "Kurnool",
    phone: "7887669525",
    email: "sabbusuri@gmail.com"
  },
  {
    id: 34,
    jnbId: "30551",
    name: "Brundavan B.Ed College",
    place: "Allagadda",
    district: "Nandyal",
    phone: "9441580669",
    email: "principale1973@gmail.com"
  },
  {
    id: 35,
    jnbId: "30605",
    name: "Sri Valli Subrahmanyeswara B.Ed College",
    place: "Banaganapalle",
    district: "Nandyal",
    phone: "6300658044",
    email: "srivalli2015bed@gmail.com"
  },
  {
    id: 36,
    jnbId: "30743",
    name: "Sri Saraswathi B.Ed College",
    place: "Karivena",
    district: "Nandyal",
    phone: "8247475518",
    email: "rajamaluga8@gmail.com"
  },
  {
    id: 37,
    jnbId: "31520",
    name: "Sri Bharathi B.Ed College",
    place: "Nandyal",
    district: "Nandyal",
    phone: "9293783562",
    email: "ynr.anantha@gmail.com"
  },
  {
    id: 38,
    jnbId: "32141",
    name: "Prathiba College of Education",
    place: "Kurnool",
    district: "Kurnool",
    phone: "9989911633",
    email: "draip1987@gmail.com"
  },
  {
    id: 39,
    jnbId: "32432",
    name: "Sumourya College of Education",
    place: "Holagunda",
    district: "Kurnool",
    phone: "7887669525",
    email: "sabbusruri@gmail.com"
  },
  {
    id: 40,
    jnbId: "24128",
    name: "Sivaranga College of Education",
    place: "Koilakuntala",
    district: "Nandyal",
    phone: "9505254485",
    email: "amadala@gmail.com"
  },
  {
    id: 41,
    jnbId: "28658",
    name: "Venkataratna College of Education",
    place: "Kurnool",
    district: "Kurnool",
    phone: "9390379066",
    email: "venkatarathnacoe@gmail.com"
  },
  {
    id: 42,
    jnbId: "32170",
    name: "Sri Shiri Baba College of Education",
    place: "Nandikotkur",
    district: "Nandyal",
    phone: "9390379066",
    email: "Shiridibabacoe@gmail.com"
  },
  {
    id: 43,
    jnbId: "32603",
    name: "Sarvswra B.Ed College",
    place: "Kurnool",
    district: "Kurnool",
    phone: "9542999061",
    email: "hp20003@gmail.com"
  },
  {
    id: 44,
    jnbId: "32156",
    name: "Sri Sudha College of Education",
    place: "Dhone",
    district: "Nandyal",
    phone: "9966670147",
    email: "srisudhabed13@gmail.com"
  },
  {
    id: 45,
    jnbId: "32166",
    name: "Sri Gayatri College of Education",
    place: "Dhone",
    district: "Nandyal",
    phone: "9985071264",
    email: "srigayathriclg2024@gmail.com"
  },
  {
    id: 46,
    jnbId: "12433",
    name: "GM College of Education",
    place: "Nandyal",
    district: "Nandyal",
    phone: "9966418448",
    email: "gmrcoe312@rediffmail.com"
  },
  {
    id: 47,
    jnbId: "46512",
    name: "Balaji College of Education",
    place: "Panchalingala",
    district: "",
    phone: "9063624614",
    email: "balajicoeknl@gmail.com"
  },
  {
    id: 48,
    jnbId: "32433",
    name: "Sharada College of Education",
    place: "Nannur",
    district: "Kurnool",
    phone: "9553722786",
    email: "sharadabedcollege@gmail.com"
  },
  {
    id: 49,
    jnbId: "15612",
    name: "Naik College of Education",
    place: "Kurnool",
    district: "Kurnool",
    phone: "8885505185",
    email: "naikbedcollege@gmail.com"
  },
  {
    id: 50,
    jnbId: "30668",
    name: "Sri Shiva Sai Krishna College of Education",
    place: "Nandikotkur",
    district: "Nandyal",
    phone: "9440364474",
    email: "sssednndk@gmail.com"
  },
  {
    id: 1,
    jnbId: "30133",
    name: "Vijaniketha B.P.Ed College",
    place: "Panyam",
    district: "Nandyal",
    phone: "9030779583",
    email: "goopireddy181@gmail.com"
  },
  {
    id: 2,
    jnbId: "30317",
    name: "Srilakshmi B.P.Ed College",
    place: "Dupadu",
    district: "Kurnool",
    phone: "9440852221",
    email: "principal.srilakshmibped@gmail.com"
  },
  {
    id: 3,
    jnbId: "32523",
    name: "Sri Datta B.P.Ed College",
    place: "Veldurthi",
    district: "Kurnool",
    phone: "9553722786",
    email: "sridattab.p.edcollege786@gmail.com"
  },
  {
    id: 1,
    jnbId: "18791",
    name: "Sri Prasunna College of Law",
    place: "Kurnool",
    district: "Kurnool",
    phone: "9440775064",
    email: "spcl107@rediffmail.com"
  }







 
  ];
